<template>
  <div name="AnnouncementDetailReplyList">
    <slot name="header"></slot>
    <ErrorMessage :status="reactionsApiStatus.status" :customMessage="reactionsApiStatus.customMessage" />
    <template v-if="reactionsApiStatus.status === 200">
      {{ statusText }}
      <template v-if="!listReaction.length">
        <div class="bg-info text-white p-1">{{ noDataMessage }}</div>
      </template>
      <template v-else>
        <ListHeader
          tableId="replyTable"
          :filteredList="filteredUserList"
          :fullList="listReaction"
          :search="search"
          :fields="replyFields"
          :pagenate="pagenate"
          textPlaceholder="名前やコメントで検索"
          @updateSearch="updateSearch"
          @changePage="changePage"
        ></ListHeader>

        <template v-if="!filteredUserList.length">
          <div class="bg-info text-white p-1">条件に合う反応はありません</div>
        </template>

        <b-table
          v-else
          id="replyTable"
          small
          stacked="sm"
          striped
          :items="filteredUserList"
          :fields="replyFields"
          :per-page="pagenate.perPage"
          :sordBy="pagenate.sortBy"
          responsive
          :sortDesc="pagenate.sortDesc"
          :current-page="pagenate.currentPage"
          @sort-changed="changeSort"
        >
          <template v-slot:cell(reply)="data">
            {{ getReplyText(data.item.reply) }}
          </template>
          <template v-slot:cell(name)="data">
            <b-link
              v-if="data.item.url_string && data.item.is_deleted === '0'"
              @click="selectProfile(data.item.url_string)"
            >
              {{ arrangedName(data.item) }}
            </b-link>
            <template v-else>
              {{ arrangedName(data.item) }}
            </template>
          </template>
          <template v-slot:cell(status)="data">
            {{ $constList.replyStateList[data.item.status] }}
          </template>
          <template v-slot:cell(updated_at)="data">
            <template v-if="data.item.status > 0">{{ data.item.updated_at }}</template>
          </template>
        </b-table>
        <slot name="bottom"></slot>
      </template>
    </template>
  </div>
</template>

<script>
import ErrorMessage from '@/components/ErrorMessage.vue'
import ListHeader from '@/components/ListHeader.vue'
import listJs from '@/transformer/list'
import { getReplyText } from '@/transformer/announcement'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'AnnouncementDetailReplyList',

  components: {
    ErrorMessage,
    ListHeader
  },

  props: {
    showUnread: {
      type: Boolean,
      default() {
        return true
      }
    },
    replyFields: {
      default() {
        return []
      }
    },
    noDataMessage: {
      default() {
        return '表示できる反応はありません'
      }
    }
  },

  data() {
    return {
      search: listJs.getEmptySearch(this.replyFields),
      pagenate: listJs.getDefaultPagenate()
    }
  },

  computed: {
    ...mapState({
      reactionsApiStatus: (state) => state.Announcement.listReactionApiStatus,
      listReaction: (state) => state.Announcement.listReaction
    }),
    ...mapGetters('Announcement/', ['selectedAnnouncement']),
    filteredUserList: function () {
      return listJs.getFilteredArray(this.listReaction, this.replyFields, this.search, this.pagenate)
    },
    statusText() {
      return (
        '未読：' +
        this.selectedAnnouncement.not_open_num +
        '　既読：' +
        this.selectedAnnouncement.open_num +
        '　返信済：' +
        this.selectedAnnouncement.reply_num +
        '　いいね：' +
        this.selectedAnnouncement.favorite_num
      )
    }
  },

  methods: {
    arrangedName: function (user) {
      if (user.is_deleted === '1') {
        return user.name + ' (削除済)'
      }
      return user.name
    },
    changePage: function (pagenate) {
      this.pagenate = pagenate
    },
    changeSort(e) {
      this.pagenate.sortBy = e.sortBy
      this.pagenate.sortDesc = e.sortDesc
    },
    selectProfile: function (urlString) {
      this.$emit('click-profile', urlString)
    },
    replyStateList: function () {
      const replyStateList = Object.keys(this.$constList.replyStateList).map((key) => {
        return { text: this.$constList.replyStateList[key], value: Number(key) }
      })
      replyStateList.unshift({ text: '全て', value: 'all' })
      return replyStateList
    },
    getReplyText: function (reply) {
      return getReplyText(this.selectedAnnouncement, reply)
    },
    updateSearch: function (e) {
      this.search = e
    }
  },
  mounted() {
    this.$store.dispatch('Announcement/updateStudentUrls', this.filteredUserList)
  },
  watch: {
    filteredUserList: function () {
      this.$emit('filter-reply', this.filteredUserList)
      this.$store.dispatch('Announcement/updateStudentUrls', this.filteredUserList)
    },
    listReaction: function () {
      this.search = listJs.getEmptySearch(this.replyFields)
    }
  }
}
</script>
